import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const submissionSchema = z.object({
  packageId: z.enum(["practice-30", "school-45", "unlimited-45"]),
  packageName: z.string().min(1),
  packagePrice: z.string().min(1),
  name: z.string().min(1),
  email: z.string().email(),
  phone: z.string().optional(),
  school: z.string().optional(),
  times: z.string().optional(),
  notes: z.string().max(8000, "Notes must be 8,000 characters or less").optional(),
});

export const submitInterviewRequest = createServerFn({ method: "POST" })
  .validator((input) => submissionSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data: inserted, error } = await supabaseAdmin
      .from("interview_requests")
      .insert({
        package_id: data.packageId,
        package_name: data.packageName,
        package_price: data.packagePrice,
        name: data.name,
        email: data.email,
        phone: data.phone ?? null,
        role: data.school ?? null,
        preferred_times: data.times ?? null,
        job_description: data.notes ?? null,
      })
      .select("id")
      .single();

    if (error) {
      console.error("Failed to save interview request:", error);
      throw new Error("Failed to save your request. Please try again.");
    }

    try {
      const { sendTemplateEmail } = await import("@/lib/email-templates/send-email");
      await sendTemplateEmail("interview-request-notification", "", {
        templateData: {
          name: data.name,
          email: data.email,
          phone: data.phone ?? "",
          school: data.school ?? "",
          times: data.times ?? "",
          notes: data.notes ?? "",
          packageName: data.packageName,
          packagePrice: data.packagePrice,
        },
        replyTo: data.email,
        idempotencyKey: `interview-request-notification-${inserted?.id ?? data.email}`,
      });
    } catch (emailError) {
      console.error("Failed to send notification email:", emailError);
    }

    return { success: true };
  });
